<template>
  <div
    class="template"
    v-if="
      selectedBot &&
      (!selectedBot.pagerole || (selectedBot.pagerole && selectedBot.pagerole == 'admin'))
    "
  >
    <main-layout>
      <template v-if="!loading">
        <template v-if="themeExist">
          <component :is="currentView"></component>
        </template>
        <template v-else>
          <component :is="'template-reporter'"></component>
        </template>
      </template>
    </main-layout>
  </div>
</template>

<script>
import reporter from '@/components/view/template/reporter/reporter'
import ecommerce from '@/components/view/template/ecommerce/ecommerce'
import oishineko from '@/components/view/template/oishineko/reporter'
import event from '@/components/view/template/event/Event'
import qualityexpress from '@/components/view/template/qualityexpress/main'
import leologistics from '@/components/view/template/leologistics/main'
import hafele from '@/components/view/template/hafele/main'
import generali from '@/components/view/template/generali/main'
import dplus from '@/components/view/template/dplus/main'
import runbetter from '@/components/view/template/runbetter/main'
import scgcareer from '@/components/view/template/scgcareer/main'
import ananda from '@/components/view/template/ananda/main'
import scgallrent from '@/components/view/template/scgallrent/main'
import pttlng from '@/components/view/template/pttlng/main'

import { mapGetters, mapMutations } from 'vuex'

export default {
  data: function () {
    return {
      // currentView: 'template-reporter'
      themeExist: false,
      loading: true,
      themes: [
        'bec',
        'reporter',
        'ecommerce',
        'sahapan',
        'ecommercebasic',
        'chatty',
        'oishineko',
        'oishineko2',
        'ananda',
        'event',
        'qualityexpress',
        'leologistics',
        'hafele',
        'generali',
        'dplus',
        'runbetter',
        'scgcareer',
        'ananda',
        'erawon',
        'scgallrent',
        'pttlng',
        'adminperform',
        'nvbb',
        'ticket',
      ],
    }
  },
  // name: 'template',
  components: {
    'template-reporter': reporter,
    'template-ecommerce': ecommerce,
    'template-oishineko': oishineko,
    'template-oishineko2': oishineko,
    'template-event': event,
    'template-qualityexpress': qualityexpress,
    'template-leologistics': leologistics,
    'template-hafele': hafele,
    'template-generali': generali,
    'template-dplus': dplus,
    'template-runbetter': runbetter,
    'template-scgcareer': scgcareer,
    'template-ananda': ananda,
    'template-scgallrent': scgallrent,
    'template-pttlng': pttlng,
  },
  mounted: function () {
    let vm = this
    $.each(vm.themes, function (index, value) {
      if (value == vm.$store.state.selectedBot.theme) {
        vm.themeExist = true
        vm.loading = false
        return false
      }
    })
    vm.loading = false
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
    }),
    currentView: function () {
      if (!this.$store.state.selectedBot) {
        return null
      }
      let theme = this.$store.state.selectedBot.theme
      switch (theme) {
        case 'ecommercebasic':
        case 'sahapan':
        case 'chatty':
        case 'erawon':
        case 'adminperform':
        case 'nvbb':
        case 'ticket':
        case 'bec':
          return 'template-ecommerce'

        default:
          return 'template-' + theme
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/Template.vue